import { useRef } from 'react';
import { BASE_PDF_STYLES } from '../../../../../utils/reportUtils';
import SuccessFormMessage from '../../../../components/messages/SuccessFormMessage';
import ReportButton from '../../../../components/report/ReportButton';
import APEntrySummary from './APEntrySummary';

const APEntrySuccess = () => {
  const summaryRef = useRef<HTMLDivElement | null>(null);

  return (
    <div className='pb-5'>
      <SuccessFormMessage
        message="The AP Transaction Entry has been uploaded successfully!"
        redirectUrl="/accounting-dashboard/new"
        redirectMessage="Click here to return to the forms list"
      />
      <div
        id="ap-entry-success"
        className="w-fit mx-auto flex flex-column gap-3"
        ref={summaryRef}
      >
        <div className="text-30px font-bold mt-6 flex justify-content-between align-items-end">
          AP Transaction Entry Summary:
          <div className="text-23px cursor-pointer printHide h-fit">
            <ReportButton
              elementToPrintRef={summaryRef}
              fileName="AP_Transaction_Entry"
              pdfStyles={BASE_PDF_STYLES}
              noButton={true}
              hideExcel={true}
              isPdfPortrait={true}
              widthElementID="ap-entry-success"
              minWidth={800}
            />
          </div>
        </div>
        <APEntrySummary />
      </div>
    </div>
  );
};

export default APEntrySuccess;
